import { render } from "./DocumentationViewer.vue?vue&type=template&id=3ce976e3&scoped=true"
import script from "./DocumentationViewer.vue?vue&type=script&lang=js"
export * from "./DocumentationViewer.vue?vue&type=script&lang=js"

import "./DocumentationViewer.vue?vue&type=style&index=0&id=3ce976e3&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce976e3"]])

export default __exports__